<template>
  <div class="page flex-col">
    <div class="box_1 flex-col justify-between">
      <HeadVue></HeadVue>
      <div class="box_4 flex-col" style="margin-left: -115px">
        <div class="box_5 flex-row justify-between">
          <img class="image_2" referrerpolicy="no-referrer"
            src="./assets/img/banner5.png" />
          <div class="text-group_1 flex-col justify-between">
            <span class="text_6">质量管控</span>
            <span class="text_7">
              借助自动化检验技术，聚焦工序数据，瞬间生成精准结果与改进建议，革新传统检验，以标准化流程确保产品质量，推动企业持续改进。
            </span>
          </div>
        </div>
        <div class="box_6 flex-row justify-between">
          <div class="text-group_2 flex-col justify-between">
            <span class="text_8">库存管理</span>
            <span class="text_9">
              利用智能算法助力盘点与分类，快速输出盘点成果与优化妙招，帮企业摆脱库存困境，提升管理效率，优化库存结构，盘活资金流。
            </span>
          </div>
          <img class="image_3" referrerpolicy="no-referrer"
            src="./assets/img/banner6.png" />
        </div>
        <div class="box_7 flex-row justify-between">
          <img class="image_4" referrerpolicy="no-referrer"
            src="./assets/img/banner7.png" />
          <div class="text-group_3 flex-col justify-between">
            <span class="text_10">财务管理</span>
            <span class="text_11">
              通过深度成本数据分析，打造实用报告与优化策略，助力企业精细管控成本、拓宽盈利空间，保障可持续发展。
            </span>
          </div>
        </div>
        <div class="box_8 flex-row justify-between">
          <img class="image_5" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
          <div class="image-text_1 flex-row justify-between">
            <span class="text-group_4">我们的优势</span>
            <img class="image_6" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
          </div>
        </div>
        <div class="box_9 flex-row justify-between">
          <div class="text-wrapper_2 flex-col"><span class="text_12">团队优势</span></div>
          <div class="text-wrapper_3 flex-col"><span class="text_13">技术领先</span></div>
        </div>
        <div class="box_10 flex-row justify-between">
          <div class="group_9 flex-col">
            <div class="text-wrapper_4">
              <ul>
                <li v-for="(item, index) in teamAdvantages" :key="index" class="paragraph_1">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <div class="group_10 flex-col">
            <div class="text-wrapper_5">
              <ul>
                <li v-for="(item, index) in techAdvantages" :key="index" class="paragraph_2">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="box_11 flex-row justify-between">
          <div class="text-wrapper_6 flex-col"><span class="text_16">高性能部署</span></div>
          <div class="text-wrapper_7 flex-col"><span class="text_17">自主可控</span></div>
        </div>
        <div class="box_12 flex-row justify-between">
          <div class="section_1 flex-col">
            <div class="text-wrapper_8">
              <ul>
                <li v-for="(item, index) in performanceAdvantages" :key="index" class="paragraph_3">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <div class="section_2 flex-col">
            <div class="text-wrapper_9">
              <ul>
                <li v-for="(item, index) in controlAdvantages" :key="index" class="paragraph_4">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <FooterVue style="margin-top: 120px"></FooterVue>
      </div>
      <div class="box_21 flex-col">
        <div class="box_22 flex-row">
          <div class="text-wrapper_18 flex-col justify-between">
            <span class="text_42">注入AI活力，重塑企业生产力新格局</span>
            <span class="text_43">
              深耕企业级应用天地，无缝衔接非结构化数据大预言模型，匠心打造全栈式数据基建根据。
            </span>
          </div>
          <img class="image_7" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNGca07f532d9799b55daeda6cc8cccf8eb.png" />
        </div>
        <div style="margin-left: -115px">
          <div class="box_23 flex-row justify-between">
            <img class="image_8" referrerpolicy="no-referrer"
                 src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
            <div class="image-text_2 flex-row justify-between">
              <span class="text-group_6">工业企业AI生产力构建</span>
              <img class="image_9" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
            </div>
          </div>
          <div class="grid_1 flex-row">
            <img class="image_10" referrerpolicy="no-referrer"
                 src="./assets/img/MasterDDSSlicePNG504bd420c55024f85492f475099b0e82.png" />
            <img class="image_11" referrerpolicy="no-referrer"
                 src="./assets/img/MasterDDSSlicePNGab9f64eddb6767de84bc1b779d59b1ce.png" />
            <img class="image_12" referrerpolicy="no-referrer"
                 src="./assets/img/MasterDDSSlicePNGe3ec642ddd5a97369e21d137ce1898fa.png" />
            <div class="text-group_7 flex-col">
              <span class="text_44">AI工具</span>
              <span class="text_45">
              基于数据驱动学习模式，自动采集并深度处理多源数据，经反复训练，精准生成具备特定功能的智能软件，有力提升任务执行的精准度与效率。
            </span>
            </div>
            <div class="text-group_8 flex-col">
              <span class="text_46">AI智能体</span>
              <span class="text_47">
              具备自主学习能力，可灵活调用&nbsp;AI&nbsp;工具，广泛吸纳知识，精准掌握特定技能，以智能代理身份独立应对复杂任务，保障工作高质量完成。
            </span>
            </div>
            <div class="text-group_9 flex-col">
              <span class="text_48">自动化工作</span>
              <span class="text_49">
              通过构建协同体系，组织多个&nbsp;AI&nbsp;智能体有序协作。针对重复性任务与工作流，依据预设流程自动分配任务，高效执行，确保工作连贯性与稳定性。
            </span>
            </div>
          </div>
          <div class="box_24 flex-row justify-between">
            <img class="image_13" referrerpolicy="no-referrer"
                 src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
            <div class="image-text_3 flex-row justify-between">
              <span class="text-group_10">开创工业场景效率的新时代</span>
              <img class="image_14" referrerpolicy="no-referrer"
                   src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
            </div>
          </div>
          <div class="box_25 flex-row justify-between">
            <img class="image_15" referrerpolicy="no-referrer"
                 src="./assets/img/banner2.png" />
            <div class="text-group_11 flex-col justify-between">
              <span class="text_50">物料管理</span>
              <span class="text_51">
              凭借卓越的数据处理技术，自动聚焦物料，深度剖析数据，快速精准生成物料信息与参数配置，大幅提升建档效率，确保数据精准连贯，为生产与供应链筑牢根基。
            </span>
            </div>
          </div>
          <div class="box_26 flex-row justify-between">
            <div class="text-group_12 flex-col justify-between">
              <span class="text_52">生产规划</span>
              <span class="text_53">
              迈入生产计划关键阶段，依托海量数据深度挖掘能力，化身专业规划大师，精心制定生产与资源优化方案，科学分配任务、精准设定时间节点，保障流程顺畅、资源最优，提升生产效能，助力企业快速响应市场。
            </span>
            </div>
            <img class="image_16" referrerpolicy="no-referrer"
                 src="./assets/img/banner3.png" />
          </div>
          <div class="box_27 flex-row justify-between">
            <img class="image_17" referrerpolicy="no-referrer"
                 src="./assets/img/banner1.png" />
            <div class="text-group_13 flex-col justify-between">
              <span class="text_54">客户关系</span>
              <span class="text_55">
              运用全方位客户数据分析技术，构思客户关系优化策略与实时档案，助力企业精准把握需求，提供个性化服务，提升满意度，拉紧客户纽带，增强竞争力。
            </span>
            </div>
          </div>
          <div class="text-group_14 flex-col justify-between">
            <span class="text_56">采购管理</span>
            <span class="text_57">
            聚焦采购关键节点，以专业评估技术审视供应商绩效与风险，输出优化建议，助企业高效管控供应商，规避风险，深化合作，保障物料供应稳定、成本效益最佳。
          </span>
          </div>
          <img class="image_18" referrerpolicy="no-referrer"
               src="./assets/img/banner4.png" />
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import HeadVue from "../common/HeadVue.vue";
import FooterVue from "../common/FooterVue.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name:'index',
  components: {
    HeadVue,
    FooterVue
  },
  data() {
    return {
      loopData0: [
        { lanhutext0: '公司简介', lanhutext1: '团队介绍' },
        { lanhutext0: '今日头条', lanhutext1: '西瓜视频' }
      ],
      teamAdvantages: [
        '公司团队在企业数字化转型与人工智能技术应用领域深耕多年，专业造诣深厚。',
        '创始成员均来自世界 500 强及头部互联网大厂，凭借深厚行业积淀、前沿技术视野与精湛专业技能，已为近百家中国企业定制化交付系统与软件解决方案。',
        '具备精准洞察行业痛点的能力，能高效赋能企业数字化变革，实战履历丰富，专业功底扎实。'
      ],
      techAdvantages: [
        '自主投入研发，攻克多项技术难关，研发出一整套 AI 原生应用开发算法与模型体系。',
        '体系涵盖工业级生成式知识管理及先进的计算智能体功能模块，具备快速复用、轻定制化能力。',
        '在低算力资源配置下，可实现卓越的高性能组合编排效果，以突破性技术引领行业前沿，为企业智能化升级提供支撑。'
      ],
      performanceAdvantages: [
        '自主构建的企业级应用开发框架设计精妙，采用模块化接口架构，实现内外部 API 接口无缝对接与高效交互。',
        '面对客户复杂多变业务需求，能依托框架迅速拓展场景应用，确保系统灵活性与扩展性。',
        '在高并发查询场景下，展现卓越稳定性与高效响应能力，保障业务流程顺畅运行，提升用户体验。'
      ],
      controlAdvantages: [
        '企业级全栈解决方案成熟稳健，底层架构设计兼容性高，适配国内外多种主流源大模型，提供多元化技术选型。',
        '支持独立环境私有化部署模式，从网络架构、数据存储到应用运行，全方位构筑安全防护体系。',
        '确保企业数据资产的安全性与合规性，让企业在数字化进程中掌握自主控制权，从容应对潜在风险。'
      ]
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
